(() => {
  function parseBlockedNames(value) {
    if (!value) return [];

    return value
      .split(',')
      .map((name) => name.trim().toLowerCase())
      .filter(Boolean);
  }

  function isBlocked(name, blockedNames) {
    const cleanName = String(name || '').trim().toLowerCase();
    return blockedNames.includes(cleanName);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatRating(value) {
    const rating = Number(value);
    if (!Number.isFinite(rating)) return '';
    return rating.toFixed(1);
  }

  function timeAgo(value) {
    if (!value) return '';

    const reviewDate = new Date(value);
    if (Number.isNaN(reviewDate.getTime())) return '';

    const now = new Date();
    const diffMs = now.getTime() - reviewDate.getTime();
    const diffDays = Math.max(0, Math.round(diffMs / 86400000));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 7) return `${diffDays} days ago`;

    if (diffDays < 30) {
      const weeks = Math.round(diffDays / 7);
      return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    }

    if (diffDays < 365) {
      const months = Math.round(diffDays / 30);
      return months === 1 ? '1 month ago' : `${months} months ago`;
    }

    const years = Math.round(diffDays / 365);
    return years === 1 ? '1 year ago' : `${years} years ago`;
  }

  function fillCard(card, review, settings) {
    const name = review.name || 'Google reviewer';
    const text = review.text || '';
    const reviewAge = timeAgo(review.date);

    const nameEl = card.querySelector('[data-reviews-google-name]');
    const textEl = card.querySelector('[data-reviews-google-text]');
    const photoEl = card.querySelector('[data-reviews-google-photo]');
    const verifiedEl = card.querySelector('.testimonial-item__author-verified');

    if (nameEl) nameEl.textContent = name;

    if (textEl) {
      textEl.textContent = text;

      const truncateLines = Number(settings.truncateLines || 0);

      if (truncateLines > 0) {
        textEl.style.display = '-webkit-box';
        textEl.style.webkitLineClamp = String(truncateLines);
        textEl.style.webkitBoxOrient = 'vertical';
        textEl.style.overflow = 'hidden';
      }
    }

    if (verifiedEl && reviewAge) {
      let ageEl = verifiedEl.parentElement.querySelector('[data-reviews-google-age]');

      if (!ageEl) {
        ageEl = document.createElement('div');
        ageEl.className = 'author-verified__review fs-body-75';
        ageEl.setAttribute('data-reviews-google-age', '');
        ageEl.style.marginTop = '2px';
        verifiedEl.insertAdjacentElement('afterend', ageEl);
      }

      ageEl.textContent = reviewAge;
    }

    if (photoEl && settings.showAuthorImage) {
      if (review.photo) {
        photoEl.innerHTML = `
          <img
            src="${escapeHtml(review.photo)}"
            alt="${escapeHtml(name)}"
            loading="lazy"
            width="64"
            height="64"
            style="width: 64px; height: 64px; border-radius: 50%; object-fit: cover;"
          >
        `;
      } else {
        photoEl.innerHTML = `
          <div style="width: 64px; height: 64px; border-radius: 50%; background: #f2f2f2; display: flex; align-items: center; justify-content: center;">
            ${escapeHtml(name.charAt(0))}
          </div>
        `;
      }
    }

    card.hidden = false;
  }

  function readReviewData(section) {
    const dataEl = section.querySelector('[data-reviews-google-json]');
    if (!dataEl) return null;

    try {
      const data = JSON.parse(dataEl.textContent || 'null');
      return data && typeof data === 'object' ? data : null;
    } catch (error) {
      console.error('Google Reviews: invalid metafield JSON', error);
      return null;
    }
  }

  function initSection(section) {
    const root = section.querySelector('[data-reviews-google-root]');
    if (!root) return;

    const data = readReviewData(section);
    const cards = Array.from(section.querySelectorAll('[data-reviews-google-card]'));

    if (!data) {
      cards.forEach((card) => { card.hidden = true; });
      return;
    }

    const limit = Number(root.dataset.limit || 6);
    const blockedNames = parseBlockedNames(root.dataset.blockedNames);
    const summary = section.querySelector('[data-google-summary]');
    const ratingEl = section.querySelector('[data-google-rating]');

    const settings = {
      showAuthorImage: root.dataset.showAuthorImage === 'true',
      truncateLines: root.dataset.truncateLines || '0'
    };

    const reviews = Array.isArray(data.reviews)
      ? data.reviews
          .filter((review) => !isBlocked(review.name, blockedNames))
          .slice(0, limit)
      : [];

    cards.forEach((card, index) => {
      const review = reviews[index];

      if (!review) {
        card.hidden = true;
        return;
      }

      fillCard(card, review, settings);
    });

    if (summary && ratingEl && data.averageRating && data.totalReviewCount) {
      ratingEl.textContent = formatRating(data.averageRating);
      summary.hidden = false;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-reviews-google-section]').forEach((section) => {
      if (section.dataset.reviewsGoogleLoaded === 'true') return;

      section.dataset.reviewsGoogleLoaded = 'true';
      initSection(section);
    });
  }

  // Script is loaded with `defer`, so the DOM is already parsed when this runs.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();